/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';
import { Route, Switch } from 'react-router';
import { wrapImport } from 'decorators/ModuleLoader';
import useSessionInfo from 'hooks/identity/useSessionInfo';
import {
  InAppNotFoundView
} from '../utils';

const DashboardPage = wrapImport(() => import(/* webpackChunkName: "views" */ 'views/Dashboard'));
const PortalDashboard = wrapImport(
  () => import(/* webpackChunkName: "views" */ 'views/Dashboard/PortalDashboard')
);

export const BusinessDashboardRoutes = ({ match }) => {
  const {
    isPortalExperience
  } = useSessionInfo();

  return (
    <Switch>
      {isPortalExperience ? (
        <Route path={match.url} exact={true} component={PortalDashboard} />
      ) : null}
      <Route path={match.url} exact={true} component={DashboardPage} />
      {InAppNotFoundView}
    </Switch>
  );
};
